import { vars } from '@repo/config';
import { createPostFetchOptions } from './helper';

interface ISetUserRoleParams {
  userId: string;
  role: string;
}

interface ISetUserRoleResponse {
  success: boolean;
  error?: string;
}

export async function setUserRole(
  cookieHeader: string,
  params: ISetUserRoleParams,
): Promise<ISetUserRoleResponse> {
  try {
    const setRoleUrl = new URL('/api/auth/admin/set-role', vars.url.identityUrl);
    const response = await fetch(
      setRoleUrl.toString(),
      createPostFetchOptions({
        cookieHeader,
        body: {
          userId: params.userId,
          role: params.role,
        },
      }),
    );

    if (!response.ok) {
      const errorData = (await response.json()) as { message?: string };
      return { success: false, error: errorData.message || 'Failed to update user role' };
    }

    return { success: true };
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Network error occurred';
    return { success: false, error: errorMessage };
  }
}
